import smartViewTexts from '../../../../shared/i18n/overview/texts';
import tagsGroupConstants from '../../../../shared/constants/overview/TagsGroupConstants';

import { isDataLoading } from '../../../../shared/axios';

export const isTotalColumn = columnName => smartViewTexts.campaignTable.totalAccount === columnName;

export const isUntagged = columnName => tagsGroupConstants.UNTAGGED === columnName;

export const getStatusByAutomation = (cluster, isBudgetManager, isBidManager) => {
    if (isBudgetManager) return cluster.isBudgetActive;
    if (isBidManager) return cluster.isTargetActive;
    return false;
};

export const isFieldLoading = ({
    cluster, updatedCluster, updatedClusterState,
}) => {
    const isEditedCluster = updatedCluster?.id === cluster?.id;
    const isEditedClusterLoading = isDataLoading(updatedClusterState);

    return (
        !cluster || (isEditedCluster && isEditedClusterLoading)
    );
};
